import React, { useContext } from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

// Import iconRegistry FIRST - it initializes Fluent UI icons at module load time
// This MUST be before any component imports that use Fluent UI icons
import './utils/iconRegistry'

import Chat from './pages/chat/Chat'
import Layout from './pages/layout/Layout'
import NoPage from './pages/NoPage'
// ResearchPage removed - will be rebuilt as Notebook LM-style feature
import HelpPage from './pages/HelpPage'
import AdminConfigPage from './components/AdminConfigPage'
import CostManagementPage from './pages/CostManagementPage'
import CloudManagementPage from './pages/CloudManagementPage'
import NewsManagement from './components/News/NewsManagement'
import AIConnectorHub from './components/AIConnectorHub/AIConnectorHub'
import AIConnectorHubPage from './pages/AIConnectorHubPage'
import UIManagement from './components/UIManagement/UIManagement'
import SwaggerDocsPage from './pages/SwaggerDocsPage'
import { AppStateProvider, AppStateContext } from './state/AppProvider'
import { AuthProvider, ProtectedRoute } from './components/Auth'
import { DataProvider } from './contexts/DataContext'
import { FeatureAccessProvider } from './context/FeatureAccessContext'

import './index.css'

export default function App() {
  return (
    <AuthProvider>
      <DataProvider>
        <AppStateProvider>
          <FeatureAccessProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/*" element={
                  <ProtectedRoute>
                    <AppContent />
                  </ProtectedRoute>
                } />
              </Routes>
            </BrowserRouter>
          </FeatureAccessProvider>
        </AppStateProvider>
      </DataProvider>
    </AuthProvider>
  )
}

function AppContent() {
  const appStateContext = useContext(AppStateContext)
  const ui = appStateContext?.state.frontendSettings?.ui
  
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Chat />} />
        {/* Research route removed - will be rebuilt as Notebook LM-style feature */}
        <Route path="help" element={<HelpPage />} />
        <Route path="admin" element={<AdminConfigPage />} />
        <Route path="ui-admin" element={<UIManagement />} />
        <Route path="news-admin" element={<NewsManagement />} />
        <Route path="cost" element={<CostManagementPage />} />
        <Route path="cloud" element={<CloudManagementPage />} />
        <Route path="api-docs" element={<SwaggerDocsPage />} />
        <Route path="ai-connector-hub" element={<AIConnectorHubPage />} />
        <Route path="*" element={<NoPage />} />
      </Route>
    </Routes>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
